import { INITIALIZE_LOGIN_STATE } from "../../constants/Login";
import * as C from "../../constants/registerVetConstants";

export type InitializeLoginStateRequestAction = ReturnType<
  typeof initializeLoginStateRequestAction
>;
export type VetCreateAccountRequestAction = ReturnType<typeof vetCreateAccountRequestAction>;
export type VetSubmitProfileRequestAction = ReturnType<typeof vetSubmitProfileRequestAction>;
export type InitializeVetRegistrationRequestAction = ReturnType<
  typeof initializeVetRegistrationRequestAction
>;

export function initializeLoginStateRequestAction() {
  return {
    type: INITIALIZE_LOGIN_STATE,
  } as const;
}

export function vetCreateAccountRequestAction(data: any) {
  return {
    type: C.SIGN_UP_REQUESTED,
    payload: data,
  } as const;
}

export function vetSubmitProfileRequestAction(data: {
  vetRegistrationPageNo: number;
  userId: number;
  vetId: number;
}) {
  return {
    type: C.VET_SUBMIT_PROFILE_REQUEST,
    payload: data,
  } as const;
}

export function initializeVetRegistrationRequestAction() {
  return {
    type: C.INITIALIZE_VET_REGISTRATION,
  } as const;
}
